/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
import Permissions from "./permission";
import Select from "react-select";
import { useSelector } from 'react-redux';
import { getPermissions, createRole } from "../../../api/settings.ts";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getUrls } from '../../../api/apiurls.js';

const AddRole = ({ refetchRole }) => {
  const translation = useSelector(state => state.root.translation);
  const MySwal = withReactContent(Swal);
  const [formDataList, setFormData] = useState({});
  // const [permissionData, setPermissionData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [permissionValues, setPermissionValues] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const firstInvalidFieldRef = useRef(null);

  // const layoutsOptions = [
  //   { label: "Adoptive Dashboard", value: "adoptive" },
  //   { label: "Operations", value: "operation" },
  //   { label: "Marketing", value: "marketing" },
  //   { label: "Staffing", value: "staffing" },
  //   { label: "Analytics", value: "analytics" },
  //   { label: "Traffic Report", value: "trafficReport" },
  // ];

  const selectPeriodOptions = [
    { label: translation["today"], value: "TODAY" },
    { label: translation["yesterday"], value: "YESTERDAY" },
    { label: translation["this_week"], value: "THIS_WEEK" },
    { label: translation["last_week"], value: "LAST_WEEK" },
    { label: translation["this_month"], value: "THIS_MONTH" },
    { label: translation["last_month"], value: "LAST_MONTH" },
    { label: translation["this_year"], value: "THIS_YEAR" },
    { label: translation["last_year"], value: "LAST_YEAR" },
  ];

  const comparePeriodOptions = [
    { label: translation["previous_period"], value: "PREVIOUS_PERIOD" },
    { label: translation["previous_year_same_period"], value: "PREVIOUS_YEAR_SAME_PERIOD" },
    { label: translation["previous_year_same_day_of_week"], value: "PREVIOUS_YEAR_SAME_DAY_OF_WEEK" },
  ];

  useEffect(() => {
    const handleModalOpen = () => {
      setFormData({});
    };

    document.getElementById("add-roles")?.addEventListener("show.bs.modal", handleModalOpen);
    
    return () => {
      document.getElementById("add-roles")?.removeEventListener("show.bs.modal", handleModalOpen);
    };
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };
  //
  const getPermissionsData = async () => {
    const res = await getPermissions({});
    if (res?.response) {
    const excludedModules = [];

    let filteredPermissoins;
    var tenantType = getUrls().tenantType;

    if(tenantType == 'all') 
      filteredPermissoins = res.response.permissions.filter(item => !excludedModules.includes(item.module));
    else
      filteredPermissoins = res.response.permissions;

     
      const permissionMap = filteredPermissoins;
     // setPermissionData(permissionMap);
      mapPermissons(permissionMap);
    }
  };
  //
  const inputChange = (target) => {
    const { value, checked } = target;
    setPermissionValues((prevCheckedValues) => {
      if (checked) {
        return [...prevCheckedValues, value];
      } else {
        return prevCheckedValues.filter((val) => val !== value);
      }
    });
  };
  const validateForm = () => {
    const errors = {};
    let focusField = null;

    if (!formDataList.title) {
      errors.title = "Role name is required";
      if (!focusField) focusField = "title";
    }

    if (!formDataList.selectedPeriod) {
      errors.selectedPeriod = "Selected period is required";
      if (!focusField) focusField = "selectedPeriod";
    }

    

    // Example additional check: Selected period can't be the same as compare period
    if (formDataList.selectedPeriod === formDataList.comparePeriod) {
      errors.comparePeriod = "Compare period cannot be the same as selected period";
      if (!focusField) focusField = "comparePeriod";
    }
    if (!formDataList.comparePeriod) {
      errors.comparePeriod = "Compare period is required";
      if (!focusField) focusField = "comparePeriod";
    }

    if (focusField) {
      firstInvalidFieldRef.current = focusField; // Save the field that needs focus
    }

    return errors;
  };

  const focusInvalidField = () => {
    if (firstInvalidFieldRef.current) {
      const field = document.getElementsByName(firstInvalidFieldRef.current)[0];
      if (field) {
        field.focus();
      }
    }
  };
  //
  const mapPermissons = (permissions) => {
    var categories = {};
    permissions.forEach(function (e) {
      if (e.module) {
        if (!categories[e.module]) {
          categories[e.module] = [];
        }
        categories[e.module].push(e);
      }
    });
    //
    var sections = {};
    for (let [key, value] of Object.entries(categories)) {
      if (!sections[key]) {
        sections[key] = {};
      }
      value.forEach(function (e) {
        if (e.section) {
          sections[key][e.section] = e;
        }
      });
    }
    //
    var operations = {};
    var totalOperations = new Set();
    for (let [key, value] of Object.entries(categories)) {
      // eslint-disable-next-line no-unused-vars
      let key2 = sections[key];
      if (!operations[key]) {
        operations[key] = {};
      }
      value.forEach(function (e) {
        if (!operations[key][e.module]) {
          operations[key][e.module] = {};
        }
        if (e.operation && !operations[key][e.module][e.operation]) {
          operations[key][e.module][e.operation] = e;
          totalOperations.add(e.operation);
        }
      });
    }
    const reportRows = [];
    const toolRows = [];
    const settingRows = [];
    const assistantRows = [];
    const chatRows = [];
    const pulseRows = [];
    const eventRows = [];
    const flowForMobile = [];
    const permissionValues = [];
    //
    for (let [key1, value1] of Object.entries(operations)) {
      for (let [key2, value2] of Object.entries(value1)) {
        var obj = {};
        obj.pagename = key2;
        for (let [key3, value3] of Object.entries(value2)) {
          obj[key3] = value3._id;

        }
        //
          reportRows.push(obj);
         if (key1 === "Tool") {
          toolRows.push(obj);
        } else if (key1 === "Settings") {
          settingRows.push(obj);
        } else if (key1 === "Assistant") {
          assistantRows.push(obj);
        } else if (key1 === "Chat") {
          chatRows.push(obj);
        } else if (key1 === "Pulse") {
          pulseRows.push(obj);
        } else if (key1 === "Event") {
          eventRows.push(obj);
        } else if (key1 === "Flow for mobile") {
          flowForMobile.push(obj);
        }
      }
    }
    //
    const myReportRows = [
      ...reportRows,
      ...toolRows,
      ...settingRows,
      ...assistantRows,
      ...chatRows,
      ...pulseRows,
      ...eventRows,
      ...flowForMobile,
    ];
    setTableData(myReportRows);
    setPermissionValues(permissionValues);
  };

  useEffect(() => {
    getPermissionsData();
  }, []);

  useEffect(() => {
    const handleModalOpen = () => {
      setFormData({});
      setPermissionValues([])
    };

    document.getElementById("add-roles")?.addEventListener("show.bs.modal", handleModalOpen);
    
    return () => {
      document.getElementById("add-roles")?.removeEventListener("show.bs.modal", handleModalOpen);
    };
  }, []);

  
  
  const submit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    setValidationErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      focusInvalidField(); // Focus first invalid field
      return;
    }
    const payload = {
      // storeId: formDataList.storeId,
      ...formDataList,
      "permissionsArray": permissionValues,
    }
    {
      setBtnLoading(true);
      try {
        const res = await createRole(payload);
        if (res) {
          document.getElementById("closeButtonRole").click();
          setBtnLoading(false);
          refetchRole()
          MySwal.fire({
            position: "top-end",
            icon: "success",
            title: "Create Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        setBtnLoading(false);
        console.log(error);
        MySwal.fire({
          position: "top-end",
          icon: "error",
          title: error.response.data.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } 
  };
  return (
    <div>
      {/* Add Role */}
      <div className="modal fade" id="add-roles">
        <div className="modal-dialog modal-dialog-centered modal-dialog-right custom-modal-two" style={{ maxWidth: "950px" }}>
          <div className="modal-content" style={{ maxWidth: "950px" }}>
            <div className="page-wrapper-new p-0">
              <div className="content" >
                <div className="modal-header border-0 custom-modal-header">
                  <button
                   id="closeButtonRole"
                    type="button"
                    className="close modal-close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="page-title">
                    <h4>{translation?.create_role || "Create Role"}</h4>
                  </div>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                      <div className="input-blocks">
                        <label>{translation?.role_name || "Role Name"}*</label>
                        <input
                          type="text"
                          placeholder={translation?.role_name}
                          value={formDataList?.title || ""}
                          className="form-control"
                          name="title"
                          onChange={handleInputChange}
                        />
                         {validationErrors.title && <span className="text-danger">{validationErrors.title}</span>}
                      </div>
                      </div>
                      <div className="col-lg-6 mb-3">
                        <div className="input-blocks">
                          <label>{translation?.description || "Description"}</label>
                          <input
                            type="text"
                            placeholder={translation?.description || "Description"}
                            value={formDataList?.description || ""}
                            className="form-control"
                            name="description"
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                   
                    </div>
                    <div className="row">
                      <div className="col-lg-6 mb-3">
                          <div className="input-blocks">
                            <label>{translation?.selected_period || "Selected Period"} *</label>

                            <Select
                              className="select"
                              options={selectPeriodOptions}
                              placeholder={translation?.selected_period || "Selected Period"}
                              name="selectedPeriod"
                              value={selectPeriodOptions.find(
                                (option) =>
                                  option.value === formDataList?.selectedPeriod
                              ) || ""}
                              onChange={(v) => {
                                handleInputChange({
                                  target: {
                                    name: "selectedPeriod",
                                    value: v.value,
                                  },
                                });
                              }}
                            />
                              {validationErrors.selectedPeriod && <span className="text-danger">{validationErrors.selectedPeriod}</span>}
                          </div>
                      </div>
                      <div className="col-lg-6 mb-3">
                        <div className="input-blocks">
                          <label>{translation?.compare_period || "Compare Period"}*</label>
                          <Select
                            className="select"
                            options={comparePeriodOptions}
                            placeholder={translation?.select_compare_period || "Select Compare Period"}
                            name="comparePeriod"
                            value={comparePeriodOptions.find(
                              (option) =>
                                option.value === formDataList?.comparePeriod
                            ) || ""}
                            onChange={(v) => {
                              handleInputChange({
                                target: {
                                  name: "comparePeriod",
                                  value: v.value,
                                },
                              });
                            }}
                          />
                          {validationErrors.comparePeriod && <span className="text-danger">{validationErrors.comparePeriod}</span>}
                        </div>
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-lg-6 mb-3">
                          <div className="input-blocks">
                            <label>Select Layout *</label>

                            <Select
                              className="select"
                              options={layoutsOptions}
                              placeholder="Select Layout"
                              name="selectedLayout"
                              value= {layoutsOptions.find(
                                (option) =>
                                  option.value === formDataList?.selectedLayout
                              )}
                              onChange={(v) => {
                                handleInputChange({
                                  target: {
                                    name: "selectedLayout",
                                    value: v.value,
                                  },
                                });
                              }}
                            />
                          </div>
                      </div>
                    </div>   */}

                    <div className="mb-0">
                      <Permissions
                        tableData={tableData}
                        premissionV={permissionValues}
                        inputChange={inputChange}
                      />
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                         {translation?.cancel || "Cancel"}
                      </button>
                      <button disabled={btnLoading} type="submit" className="btn btn-submit">
                        {/* {btnLoading ? 'Wait...':'Save'} */}
                        {btnLoading ? translation?.wait || "Wait..." : translation?.save || "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Role */}
    </div>
  );
};

export default AddRole;